import { createContext, useContext, useEffect, useState } from "react";
import { admin, setToken } from "../lib/api";

const AdminCtx = createContext(null);
export const useAdmin = () => useContext(AdminCtx);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    admin.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setChecked(true));
  }, []);

  const login = async (email, password) => {
    const r = await admin.post("/auth/login", { email, password });
    if (r.data.token) setToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = async () => {
    try { await admin.post("/auth/logout"); } catch { /* noop */ }
    setToken(null);
    setUser(false);
  };

  return <AdminCtx.Provider value={{ user, checked, login, logout }}>{children}</AdminCtx.Provider>;
}
